/**
 * Register Store used for connecting specific services with the general register.
 */
/* @ngInject */
function integrationStoreService ($window, IntercomService, SegmentService, VitallyService) {
  // Integrations allowed for development
  if ($window.devEnv || $window.location.origin === 'https://api.deskfy.io') {
    return [IntercomService, SegmentService]
  }
  // Integrations allowed for production
  return [IntercomService, SegmentService, VitallyService]
}

export { integrationStoreService }
